import React, { useEffect } from "react";
import { BASE_URL, DOMAIN } from "./../../global";
import Tables from "../../utils/components/tables";
import moment from "moment";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import {
  Button,
  TableContainer,
  Toolbar,
  TextField,
  Autocomplete,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { showComponent } from "../helper/helpers";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import axiosWithToken from "../../utils/components/axiosTokenConfig";

var columns = [
  {
    id: "id",
    label: "Sr. No.",
    align: "left",
    minWidth: 40,
  },
  {
    id: "clientName",
    label: "Client Name",
    align: "left",
    minWidth: 40,
  },
  {
    id: "circleName",
    label: "Circle Name",
    align: "left",
    minWidth: 40,
  },
  {
    id: "lotNo",
    label: "Lot No",
    align: "left",
    minWidth: 40,
  },
  {
    id: "noOfJobs",
    label: "Number of Jobs",
    align: "left",
    minWidth: 40,
  },
];

const TransactionControlLotsList = () => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [searchBy, setSearchBy] = React.useState("");
  const [searchKey, setSearchKey] = React.useState("");
  const [totalRows, setTotalRows] = React.useState(0);
  const _clientId = localStorage.getItem("clientId");
  const _userType = localStorage.getItem("type");
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);
  const [data, setFinalData] = React.useState([]);
  const [clientList, setClientList] = React.useState([]);
  const [selectedClient, setSelectedClient] = React.useState(null);

  const getQuery = (count) => {
    let whereConditions = "";
    let pagination_settings = "";

    if (searchBy !== "" && searchKey != "") {
      let colName = {
        "Circle Name": "c.name",
      }[searchBy];
      whereConditions = `where ${colName} like '%${searchKey}%'`;
    }

       if (_userType == 3)
      whereConditions +=
        whereConditions.length > 0
          ? ` and c.clientId = ${_clientId}`
          : ` where c.clientId = ${_clientId}`;

    if (selectedClient) {
      whereConditions +=
        whereConditions.length > 0
          ? ` and c.clientId = ${selectedClient}`
          : ` where c.clientId = ${selectedClient}`;
    }

    if (rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${
        rowsPerPage * Number(page)
      }`;
    }

   let data = { query: `SELECT tcl.*, c.name AS circleName, tf.transformerCapacity, clients.name AS clientName FROM transactionControlLots tcl LEFT JOIN circles c ON tcl.circleId = c.id LEFT JOIN transformerTypes tf ON tcl.mostTransformersCapacity = tf.id LEFT JOIN clients ON c.clientId = clients.id ${whereConditions} ORDER BY tcl.id DESC ${pagination_settings}` };


    if (count)
      data.query = `SELECT COUNT(*) AS no_of_rows FROM transactionControlLots tcl LEFT JOIN circles c ON tcl.circleId = c.id LEFT JOIN transformerTypes tf ON tcl.mostTransformersCapacity = tf.id LEFT JOIN clients ON c.clientId = clients.id ${whereConditions}`;
    return data;
  };

  // api calls
  function getTotalRows() {
    let data = getQuery(true);

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        console.log("datasheet data fetching error: ", err);
      });
  }

  function fetchFinalData() {
    let data = getQuery();

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setFinalData(res.data);
      })
      .catch((err) => {
        console.log("  error: ", err);
      });
  }

  const search = () => {
    fetchFinalData();
  };

  const handleDelete = (id) => {
    let url = BASE_URL;
    axiosWithToken
      .delete(url + `transactionControlLots/${id}`)
      .then((res) => {
        toast("TransactionControlLots is deleted!");
        setTimeout(refresh, 500);
      })
      .catch((error) => {
        toast.error("Something Went Wrong!");
      });
  };

  const fetchClients = () => {
    let url = BASE_URL;
    let SQLQuery = { query: "SELECT id, name FROM clients" };

    axiosWithToken
      .post(url + `dynamic`, SQLQuery)
      .then((res) => {
        setClientList(res.data);
      })
      .catch((error) => {
        console.log("Error fetching clients: ", error);
      });
  };

  var refresh = () => {
    window.location.reload(false);
  };

  useEffect(() => {
    getTotalRows();
    fetchClients();
  }, []);

  useEffect(() => {
    fetchFinalData();
  }, [rowsPerPage, page]);

  const actions = [
    {
      id: "edit",
      tooltip: "Edit TransactionControlLots",
      link: true,
      linkTo: (row) => `/transactionControl/${row.id}`,
      icon: <PreviewIcon />,
    },
    {
      id: "delete",
      tooltip: "Delete transactionControlLots",
      icon: <DeleteIcon style={{ color: "#dc3545" }} />,
      handler: (row) =>
        window.confirm("Are you sure you want to delete this?") &&
        handleDelete(row?.id),
    },
  ];

  return (
    <div>
      <TableContainer component={Paper} sx={{ mt: 2, p: 2 }}>
        <Toolbar>
          {showComponent("add") && (
            <Button
              variant="contained"
              size="small"
              component={Link}
              to="/transactionControl"
            >
              <b>ADD NEW</b>
            </Button>
          )}
        </Toolbar>
        <br />
        <div
          className="mb-2"
          style={{
            display: "flex",
            float: "left",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <div
            className="mb-2"
            style={{
              display: "flex",
              float: "left",
              justifyContent: "flex-end",
            }}
          >
            <Autocomplete
              sx={{
                m: 0,
                minWidth: 210,
                marginLeft: "10px",
              }}
              size="small"
              id="combo-box-demo"
              options={
                _userType == 3
                  ? clientList?.filter((client) => client.id == _clientId)
                  : clientList
              }
              getOptionLabel={(option) => option.name || ""}
              onChange={(event, newValue) => {
                setSelectedClient(newValue ? newValue.id : null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Client"
                  variant="outlined"
                />
              )}
            />

            <Autocomplete
              sx={{
                m: 0,
                minWidth: 180,
                marginLeft: "10px",
              }}
              size="small"
              id="combo-box-demo"
              options={
                _userType != 3
                  ? [
                      {
                        key: "c.name",
                        label: "Circle Name",
                      },
                    ]
                  : [
                      {
                        key: "c.name",
                        label: "Circle Name",
                      },
                    ]
              }
              renderInput={(params) => (
                <TextField {...params} label="Search By" />
              )}
              onInputChange={(event, newInputValue) => {
                setSearchBy(newInputValue);
              }}
            />
            <TextField
              id="outlined-basic"
              label={"enter " + searchBy}
              size="small"
              variant="outlined"
              onChange={(e) => setSearchKey(e.target.value)}
            />
            <Button
              variant="contained"
              size="small"
              sx={{ m: 0 }}
              style={{ marginLeft: "10px" }}
              onClick={() => {
                search();
              }}
            >
              <SearchIcon />
            </Button>
          </div>
        </div>
        <br />
        <Tables
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          handleDelete={handleDelete}
          columns={columns}
          finalData={data}
          actions={actions}
          totalRows={totalRows}
        />
      </TableContainer>
    </div>
  );
};

export default TransactionControlLotsList;
